<div class="dialog-container dialog-white-bg">
  <h2>{{ data.title }}</h2>
  @if (data.subTitle) {
    <p class="sub-title">{{ data.subTitle }}</p>
  }

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    @if (!data.isUpdate) {
      <div class="form-group domain-type-selection">
        <label>{{ 'SETTINGS.GENERAL.DOMAINS.TYPE' | translate }}</label>
        <div class="radio-group">
          @if (showClientOption) {
             <orbit-form-extended-checkbox
                [type]="'radio'"
                [item]="'SETTINGS.GENERAL.DOMAINS.CLIENT_APP.TITLE' | translate"
                [subtitle]=" 'SETTINGS.GENERAL.DOMAINS.CLIENT_DESCRIPTION' | translate "
                [name]="'domain-type'"
                [value]="'client'"
                [controller]="domainType"
                [showFavorite]="false" />
            }
          @if (showMainOption) {
            <orbit-form-extended-checkbox
              [type]="'radio'"
              [item]="'SETTINGS.GENERAL.DOMAINS.MAIN_APP.TITLE' | translate"
              [subtitle]=" 'SETTINGS.GENERAL.DOMAINS.MAIN_DESCRIPTION' | translate "
              [name]="'domain-type'"
              [value]="'main'"
              [controller]="domainType"
              [showFavorite]="false" />
          }
          @if (!showClientOption && !showMainOption) {
            <div class="all-domains-used">
              {{ 'SETTINGS.GENERAL.DOMAINS.ALL_DOMAINS_USED' | translate }}
            </div>
          }
        </div>
      </div>
    }

    <div class="form-group">
      <label for="domain">
        {{ 'SETTINGS.GENERAL.DOMAINS.NAME' | translate }}
        <span class="required">*</span>
      </label>
      <orbit-input
        type="text"
        id="domain"
        class="form-control"
        [name]="'domain'"
        [controller]="domain"
      />
      @if (domain.invalid && domain.touched) {
        <div class="error-message">
          @if (domain.errors?.['required']) {
            <span>{{ 'SETTINGS.GENERAL.DOMAINS.NAME_REQUIRED' | translate }}</span>
          }
          @if (domain.errors?.['pattern']) {
            <span>{{ 'SETTINGS.GENERAL.DOMAINS.NAME_PATTERN' | translate }}</span>
          }
        </div>
      }
    </div>

    <div class="dialog-actions">
      <orbit-button
        type="button"
        variant="secondary"
        [label]="data.cancelLabel"
        (onClick)="onCancel()">
      </orbit-button>
      <orbit-button
        type="submit"
        variant="primary"
        [label]="data.confirmLabel"
        [disabled]="form.invalid">
      </orbit-button>
    </div>
  </form>
</div>
